export default "__VITE_ASSET__Bmo7TxIL__"